import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const businessSelector = (state: State) => state.business.business;
export const totalSelector = (state: State) => state.business.total;
export const noMoreSelector = (state: State) => state.business.noMore;
export const pageSelector = (state: State) => state.business.page;
export const errorCodeSelector = (state: State) => state.business.errorCode;

const businessesIdsSelector = (state: State) => state.business.businesses.ids;
const businessesEntitiesSelector = (state: State) =>
  state.business.businesses.entities;

export const businessesSelector = createSelector(
  [businessesIdsSelector, businessesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);
